import { IGadCountry } from '@global/types/types';
import { PreviewDeliveryOption } from '@global/utils/orderUtils';

export interface PaybBillingAddress {
  upaLine1: string;
  upaLine2: string;
  upaCity: string;
  gadStateOrProvince: string;
  gadCountry: IGadCountry;
  upaPostcode: string;
  wCountry?: null | string;
  uid?: string;
}

export interface ShippingAddress {
  upaLine1: string;
  upaLine2: string;
  upaCity: string;
  gadStateOrProvince: string;
  gadCountry: IGadCountry;
  wCountry?: null | string;
  upaPostcode: string;
  upaEmail: string;
  upaPhoneNumber: string;
  wFirstName: string;
  wLastName: string;
  uid?: string;
}

export interface PaybBillingAddressView {
  addressOne: string;
  addressTwo: string;
  city: string;
  state: string;
  country: {
    name: string;
    numericCode: string;
    iso2Code?: string;
  };
  zip: string;
  uid?: string;
}

export interface ShippingAddressView {
  addressOne: string;
  addressTwo: string;
  city: string;
  state: string;
  phone: string;
  country: {
    name: string;
    numericCode: string;
    iso2Code?: string;
  };
  zip: string;
  firstName: string;
  lastName: string;
  email: string;
  uid?: string;
  deliveryInfo?: PreviewDeliveryOption;
}

export enum STATUSES {
  FALSE = 'false',
  TRUE = 'true',
  PENDING = 'pending',
}

export interface paymentInfo {
  appId: string;
  region: string;
  currency: string;
  amount: number;
  intentType: string;
  timestamp: number;
  email: string;
  paymentMethods?: string[];
  paymentToken: string;
  paymentReference: string;
}
